import { ReactElement } from 'react'
import { TypedReadOnlyV2, TypedInputV2 } from '../TypedFormFieldV2'
import type { ContactJson } from 'app/types/entities'
import { getFieldConfig, getFieldValue } from 'lib/contactFieldConfig'

/**
 * Unified V2 field renderer - uses same logic as V1 but with V2 components
 * Ensures consistent field rendering across spotlight and additional fields
 */
export function renderContactFieldV2({
  fieldId,
  contact,
  campaignName,
  isSpotlight = false,
}: {
  fieldId: string
  contact: ContactJson
  campaignName?: string
  isSpotlight?: boolean
}): ReactElement | null {
  const fieldConfig = getFieldConfig(fieldId)
  if (!fieldConfig) return null

  const value = getFieldValue(fieldId, contact, campaignName)

  // Handle lifecycle field styling (green for certain values)
  let className = fieldConfig.className
  if (fieldId === `lifecycle` && (value === `New Patient Scheduled` || value === `Lead`)) {
    className = `text-green-600`
  }

  if (fieldConfig.isEditable) {
    return (
      <TypedInputV2<ContactJson>
        field={fieldConfig.editFieldName as keyof ContactJson}
        label={fieldConfig.label}
        value={value}
        emptyMessage="—"
        className={className}
        isSpotlight={isSpotlight}
      />
    )
  }

  return (
    <TypedReadOnlyV2<ContactJson>
      field={fieldId as keyof ContactJson}
      label={fieldConfig.label === `Date of Birth` ? fieldConfig.label : fieldConfig.label.replace(`Date`, ``)}
      value={value}
      emptyMessage="—"
      isDate={fieldConfig.isDate}
      isPhone={fieldConfig.isPhone}
      canCopy={fieldConfig.canCopy}
      className={className}
      isSpotlight={isSpotlight}
    />
  )
}
